import { render, staticRenderFns } from "./ca-activation.vue?vue&type=template&id=b913b7bc&scoped=true&"
import script from "./ca-activation.vue?vue&type=script&lang=js&"
export * from "./ca-activation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b913b7bc",
  null
  
)

export default component.exports